import React, { useState } from 'react';
import { Container, Grid, Box, Button, Typography, Collapse, Divider } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const styles = {
  questionBox: {
    padding:'10px',
    width: '80vw',
    borderRadius: '4px',
    marginBottom: '10px',
    display: 'flex',
    fontFamily: 'GillSansSemiBold, sans-serif',
    fontSize: '3.55556vw',
    flexDirection: 'column',
    fontSize:{xs:'18px'}
  },
  questionHeader: {
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'GillSansSemiBold, sans-serif',
    fontSize: '5.55556vw',
    justifyContent: 'space-between',
    color: 'black',
  },
  expandableContent: {
    padding: '5px',
  },
};

function QuestionBox({ question, content, expanded, onToggle }) {
  return (
    <Box sx={styles.questionBox}>
      <Box sx={styles.questionHeader}>
        <Typography
          variant="h6"
          sx={{
            fontFamily: 'GillSansSemiBold',
            fontSize: { xs: '2.7vw', md: '1.55556vw', }, // Increase font size for mobile
            backgroundColor: 'transparent',
            color: '#000',
            paddingRight: '4%',
            paddingLeft: '0',
            fontWeight: '750',
          }}
        >
          {question}
        </Typography>
        <Button onClick={onToggle} sx={{ color: '#CF2230' }}>
          {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </Button>
      </Box>

      <Collapse in={expanded}>
  <Box sx={styles.expandableContent}>
    {Array.isArray(content) ? (
      <ul style={{ paddingLeft: "20px", margin: 0 }}>
        {content.map((item, i) => (
          <li key={i}>
            <Typography
              variant="body2"
              sx={{
                fontFamily: "Roboto-Regular",
                fontSize: { md: "1.3vw", xs: "2.7vw", sm: "2.4vw" },
                marginBottom: "6px",
              }}
            >
              {item}
            </Typography>
          </li>
        ))}
      </ul>
    ) : (
      <Typography
        variant="body2"
        sx={{
          fontFamily: "Roboto-Regular",
          fontSize: { md: "1.3vw", xs: "2.7vw", sm: "2.4vw" },
        }}
      >
        {content}
      </Typography>
    )}
  </Box>
</Collapse>

    </Box>
  );
}


export default function App() {
  const [expanded, setExpanded] = useState(null);

  const contents = [
   
'The MG Windsor EV is a 5 seater CUV.',
"The battery capacity of the MG Windsor EV is 38 kWh.",
"Yes, the MG Windsor EV has a Infinity View Glass Roof",
'The introductory price of the MG Windsor EV is ₹9.99 Lakh* + ₹3.5/Km.',
'The Aero-Lounge seats recline up to 135°',
'The Tyre specifications of the MG Windsor EV is 215/60 R17 & 215/55 R18 Alloy Wheel.',
// 'Yes, the MG Windsor EV has free public charging for 1 year.',
'Yes, the MG Windsor EV has a lifetime battery warranty.',
'The "Battery As A Service (BAAS)" program allows customers to purchase the Intelligent CUV Windsor at a lower upfront initial cost (Excluding battery cost) and pay for the battery on a pay-per-usage model. This reduces the upfront cost of buying an EV and offers flexibility in payments.',
'Yes, the MG Windsor Essence Pro & Exclusive Pro will be offered with the 3-60 Buyback plan',
'No, 52.9kWh Windsor Exclusive Pro comes with dual tone ivory interiors. Knight Black Interiors is offered in 38kWh Windsor',
'Yes, 7.4kWh charger comes with both, MG Windsor Essence Pro & Exclusive Pro and would be included in the Ex-showroom price',
'The Windsor Exclusive Pro & Windsor Essence Pro will be available with 52.9KWh battery and will offer 449kms (certified by MIDC P1+P2',
[
  "52.9kWh battery that offers a certified range of 449km",
  "9 Speakers Audio System by Infinity",
  "Dual tone ivory interiors",
  "R18 dual tone machined alloy wheels",
  "7.4 kW AC Fast Charger"
],
,
'Windsor Pro comes in two variants - Exclusive Pro & Essence Pro',
'You can lock your Windsor Exclusive Pro with Booking Amount of Rs.11000/-',
'Booking opens on 22nd May',
'We will soon update you with the expected delivery starting schedule',
'Battery rental range under BaaS starts from Rs. 4.5 per km for Windsor Pro EV.',
'Windsor Exclusive Pro comes with 9 Speakers Audio System by Infinity which includes 4 Speakers, 4 Tweeters and 1 Subwoofer whereas Windsor Exclusive comes with 6 speakers.',
'Book your Windsor Exclusive Pro at the earliest to avoid (minimize) the waiting period',
'Windsor Exclusive Pro is equipped with larger battery back of 52.9 kWh offering a certified range of 449 kms (MIDC P1 + P2), thereby giving a better peace of mind during longer drives',
'It offers a better economical option if your usage is not high (predominantly city drive). ',
'No, ADAS (Autonomous Level 2) is available only in Windsor Essence Pro',
'Currently, there is no tracking sequence for Exclusive Pro',
'If a customer changes his booking from Essence Pro to Exclusive Pro he loses the price protection, also we presume that the changes will be bare minimum because the price difference (from price protection) is ~25k and features are much more worthy.',
'Yes, The VINs for the same need to be blocked in DMS',
'No, Please share the same draft of SMS/ WhatsApp/ Email being used for Windsor Essence Pro',
'Although Exclusive Pro is equipped with larger battery back of 52.9 kWh, but Essence has additional features like Sunroof, 256 color Ambient lighting, Front ventilated seats, PM 2.5 filter with economical price',
[
  'Exclusive Pro: Rs. 17,24,800 (BaaS Price Rs.12,24,999)',
  'Essence Pro: Rs. 18,09,800 (BaaS Price Rs.13,09,999)'
],
[
  "With the 7.4kWh AC charger, 10 -100% will take 9.5hrs (appx)",
  "With the 60kWh DC charger, 20 -80% will take 50mins (appx)"
],
  ["Windsor Exclusive Pro comes with 3 Colors:",
"STARBURST BLACK",
"PEARL WHITE",
"TURQUOISE GREEN",
"Windsor Essence Pro comes with 6 colors:",

"STARBURST BLACK",
"PEARL WHITE",
"TURQUOISE GREEN",
"Celadon Blue",
"Glaze Red",
"Aurora Silver"]
  ];

  const handleToggle = (index) => {
    setExpanded(expanded === index ? null : index);
  };

  return (
    <Container>
      <Box
  id="features"
  sx={{
    width: '100%',
    height: { md: '100%', xs: '100%',sm:'100%' },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    
  }}
>
  <Typography
    variant="h2"
    sx={{
      fontSize: { md: '2.08333vw', xs: '4.7vw' },
      color: '#cf2230',
      fontFamily: 'Gill Sans, Gill Sans MT, Calibri, sans-serif',
      paddingBottom: { md: '3.125vw', xs: '5.4vw' },
      fontWeight: '400',
      marginTop: { xs: '50px' },
    }}
  >
    Frequently Asked Questions
  </Typography>
  <Grid container spacing={1}>
    <Grid item xs={12} md={12}>
      <Box
        sx={{
          fontFamily: 'GillSansSemiBold',
          fontSize: { md: '5.55556vw' },
          backgroundColor: 'transparent',
          color: '#000',
          paddingRight: '4%',
          paddingLeft: '0',
        }}
      >
        {[
          'What is the seating capacity of the MG Windsor EV?',
          'What is the battery capacity of the MG Windsor EV?', 
          'Does the MG Windsor EV have a glass roof?',
          'What is the starting price of the MG Windsor EV?', 
          'How far do the rear seats recline?',
          'What are the tyre specifications of the MG Windsor EV?',
          // 'Does the MG Windsor EV have free public charging?',
          'Does the MG Windsor EV come with a lifetime battery warranty?',
          'What is BaaS?',
          'Is 3-60 Buyback plan available for Windsor Exclusive Pro EV?',
          'Does the customer have an option to choose between Knight black and Dual Tone Ivory Interiors in Exclusive Pro?',
          'Will the MG Windsor Pro also come with 7.4kWh charger with car?',
          'What would be the size of the battery? And what would be the range of the Windsor Exclusive Pro?',
          'What new on the MG Windsor Exclusive EV Pro?',
         'How many variant options will be available in Windsor Pro?',
         'What would be the booking amount of MG Windsor Exclusive Pro?',
         'When can I book Windsor Exclusive Pro?',
         'When are the deliveries starting from Windsor Exclusive Pro?',
         'What is per km cost to run the Windsor under the BaaS program?',
         'What makes the audio system in Windsor Exclusive Pro different from Windsor Exclusive?',
         'Is there a specific waiting time for Windsor Exclusive Pro?',
         'Why should I upgrade from Windsor Exclusive to Windsor Exclusive Pro?',
         'Why should I choose Windsor Exclusive rather than Exclusive Pro?',
         'Will Windsor exclusive pro have ADAS (Autonomous Level 2)?',
         'Whether we need to track sequence no for Exclusive Pro orders starting fresh or in continuation to existing Windsor Essence Pro?',
         'When variant change be allowed from Essence Pro to Exclusive Pro or vice versa?',
         'If wholesale is happening to dealers in this week, whether we need to block the VINs for retail?',
         'Whether there is any change in customer SMS/ WhatsApp/ Email for Windsor Exclusive Pro or same as Essence Pro?',
         'Why should I prefer Essence over Exclusive Pro?',
         'Will Windsor Exclusive Pro EV also come with Lifetime Warranty?',
         'What would be the price of Windsor PRO?',
         'What will be the charging time for the Windsor Pro variant?',
         'Which colors options are available in Windsor Exclusive Pro?'

        ].map((question, index) => (
          <React.Fragment key={index}>
            <QuestionBox
              question={question}
              content={contents[index]}
              expanded={expanded === index}
              onToggle={() => handleToggle(index)}
            />
            {index < contents.length - 1 && (
              <Divider
                sx={{
                  margin: '10px 0',
                  backgroundColor: 'black',
                  height: '2px',
                  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
                }}
              />
            )}
          </React.Fragment>
        ))}
      </Box>
    </Grid>
  </Grid>
</Box>

    </Container>
  );
}
